var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CC6699;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64,
    cy: 64,
    r: 50
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.9,41.8c-0.6-2.4-2.3-4.4-4.9-5.8c-5.1-2.7-13.3-2.8-20.8-0.1c-4.5,1.6-13,5.2-19.4,11.1  c-6.4,6-7.4,11.3-6.9,13.4c1.1,5.8,7.2,9.9,12,13.3c1.3,0.9,2.5,1.7,3.4,2.5c-2.7,1.4-10,5.5-12,9.8c-1.5,3.4-0.8,5.9-0.2,7  c0.6,1.3,1.6,2.3,2.6,2.6c1,0.3,2.1,0.4,3.2,0.4c4.3,0,8.5-2.3,11.1-6.2c2.6-3.9,2.8-9.1,1.6-12.3c1.7-0.4,3.5-0.4,5.5-0.2  c3.9,0.5,5.8,2,6.7,3.2c1,1.3,1.2,2.6,1.1,3.4c-0.2,1.5-1.4,2.4-2,2.8c-0.5,0.3-0.9,0.6-0.8,1.2c0.2,0.8,1,0.7,1.3,0.7  c0.9-0.2,4.1-1.8,4.3-5.4c0.1-2.2-0.8-4.4-2.5-6.2c-2.2-2.3-5.5-3.5-9.3-3.4c-2.8,0-4.7,0.3-6.2,0.8c0,0-0.1-0.1-0.1-0.1  c-1.4-1.5-3.3-2.9-5-4.3c-4-3-7.7-5.9-7.5-10.2c0.3-5.4,5.6-10.7,15.9-15.8c9.1-4.5,16.5-4.7,20.4-3.3c1.6,0.6,2.7,1.4,3.1,2.3  c0.8,1.7,0.5,3.9-0.9,6.3c-2.3,4-8.1,9-17,10c-5.4,0.6-7.7-1.8-7.8-1.9c-0.6-0.7-1-1.1-1.7-0.7c-0.8,0.4-0.4,1.5-0.2,1.9  c0.4,1.1,2.1,3,5,4c2.3,0.8,8.2,1.3,15.5-1.5C86.8,57.7,92.6,48.7,90.9,41.8z M56.4,84.4c-0.1,0.2-0.1,0.4-0.2,0.6  c-0.1,0.2-0.2,0.4-0.2,0.6c-0.4,0.9-1,1.8-1.8,2.6c-2.3,2.5-5.4,3.2-6.4,2.6c-0.3-0.2-0.4-0.5-0.5-0.9c-0.2-1.2,0.5-3.6,2.6-5.7  c2.5-2.6,6-4.5,6.8-4.9C57,81.1,56.9,82.8,56.4,84.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass);
export default __webpack_public_path__ + "static/media/sass.97834df6a59e5c09244d0c18bd645d27.svg";
export { ForwardRef as ReactComponent };